import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidenavigationComponent } from "./sidenavigation.component";
import { TranslateModule } from "@ngx-translate/core";
import { A11yModule } from '@angular/cdk/a11y';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        A11yModule,
        TranslateModule,
    ],
  declarations: [
    SidenavigationComponent
  ],
  exports: [
    SidenavigationComponent
  ]
})
export class SidenavigationModule {}
